import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import SectionTitle from 'components/section-title'
import ShowChartIcon from 'components/material-symbol/icons/ShowChart'
import useCoachBenchmarks from 'pages/pga-coach/benchmarks/use-coach-benchmarks'
import { BENCHMARK_CARD_SUBTITLE, COACH_BENCHMARKS_PATH } from './constants'
import BenchmarkMetricRow from './benchmark-metric-row'
import useStyles from './styles'

const PerformanceBenchmarks = () => {
  const classes = useStyles()
  const { metrics, loading } = useCoachBenchmarks()

  if (loading || !metrics.length) {
    return null
  }

  return (
    <Box className={classes.section}>
      <Box className={classes.card}>
        <Box className={classes.cardHeader}>
          <Box className={classes.cardHeaderLeft}>
            <Box className={classes.iconCircle}>
              <ShowChartIcon />
            </Box>
            <Box className={classes.cardTitleBlock}>
              <SectionTitle className={classes.cardTitle}>
                How you're doing
              </SectionTitle>
              <Typography component="span" className={classes.cardSubtitle}>
                {BENCHMARK_CARD_SUBTITLE}
              </Typography>
            </Box>
          </Box>
          <Button
            component={RouterLink}
            to={COACH_BENCHMARKS_PATH}
            className={classes.cardAction}
          >
            View benchmarks
          </Button>
        </Box>

        <Box className={classes.metricList}>
          {metrics.map(metric => (
            <BenchmarkMetricRow
              key={metric.id}
              metric={metric}
              classes={classes}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default PerformanceBenchmarks
